export default __webpack_public_path__ + "static/media/swiftWriter3Low.ffa448cb.jpg";